import React from 'react';
import styled from '@emotion/styled';
import { Button, Form, Input, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { MESSAGE_ERROR } from '../../../constants/message';
import { LOGIN_TRANSLATION } from '../../../constants/define/translation';
import { appStyles } from '../../../styles';

interface LoginFromProps {
  onLogin: (values: { email: string; password: string }) => void;
  isError: boolean;
  errorMessage?: string;
}

export const LoginForm = (props: LoginFromProps) => {
  const { t } = useTranslation(LOGIN_TRANSLATION);
  const { isError, onLogin, errorMessage } = props;
  return (
    <StyledDivLogin>
      <Form name="basic" onFinish={onLogin}>
        <Form.Item
          name="email"
          rules={[{ required: true, message: t('validate.emailBlank') }]}
          className="form-item-email"
        >
          <Input type="text" placeholder={t('email')} />
        </Form.Item>
        <Form.Item name="password" rules={[{ required: true, message: t('validate.passwordBlank') }]}>
          <Input placeholder={t('password')} type="password" />
        </Form.Item>
        {isError && <Typography.Text type="danger">{errorMessage || MESSAGE_ERROR.M01}</Typography.Text>}
        <StyledButtonLogin size="large" type="primary" htmlType="submit">
          {t('loginBtn')}
        </StyledButtonLogin>
      </Form>
    </StyledDivLogin>
  );
};

const StyledDivLogin = styled.div`
  & input {
    border-radius: 20px;
    height: 46px;
    ${appStyles.color.black}
  }

  & .form-item-email {
    margin: 4vh 0 2vh 0;
  }
`;

const StyledButtonLogin = styled(Button)((props: any) => ({
  borderRadius: '20px',
  height: '46px',
  borderColor: props.theme.color.black,
  background: props.theme.color.black,
  width: '80%',
  position: 'absolute',
  left: '10%',
  right: '10%',
  bottom: '4vh',
}));
